export const state = {
  playlist: {},
  needsToUpdate: false
};
